
export default {
  computed:{
    bankCashoutList(){
      let {cashout_type} =this.formData||{}
      let arr = this.bankList.reduce((res,item)=>{
        if(item.cashout_type==cashout_type){
          res = item.banks
        }
        return res
      },[])
      return arr
    },
  },
  // async mounted() {
  //   await this.getBankList()
  // },
  // methods: {
  //   async getBankList(){
  //     let {data} = await getBankList()
  //     this.bankCashoutList = data
  //   }
  // }
}
